import{useRef as e,useEffect as n}from"react";var t=function(t,r){var o=e(null);return n(function(){return document.addEventListener(t,r),function(){document.removeEventListener(t,r)}},[t,r]),o};export{t as default};
//# sourceMappingURL=index.js.map
